import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrivateTripTRPage = lazy(() => import('../pages/private-trip-TR/page'));
const PrivateTripTRTermsPage = lazy(() => import('../pages/private-trip-TR/terms-of-use/page'));
const PrivateTripTRAgreementPage = lazy(() => import('../pages/private-trip-TR/agreement/page'));
const MICERetreatsTRPage = lazy(() => import('../pages/MICE-Retreats-TR/page'));
const MICERetreatsTRAgreementPage = lazy(() => import('../pages/MICE-Retreats-TR/agreement/page'));
const MICERetreatsTRTermsPage = lazy(() => import('../pages/MICE-Retreats-TR/terms-of-use/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/private-trip-TR',
    element: <PrivateTripTRPage />
  },
  {
    path: '/private-trip-TR/terms-of-use',
    element: <PrivateTripTRTermsPage />
  },
  {
    path: '/private-trip-TR/agreement',
    element: <PrivateTripTRAgreementPage />
  },
  {
    path: '/MICE-Retreats-TR',
    element: <MICERetreatsTRPage />
  },
  {
    path: '/MICE-Retreats-TR/agreement',
    element: <MICERetreatsTRAgreementPage />
  },
  {
    path: '/MICE-Retreats-TR/terms-of-use',
    element: <MICERetreatsTRTermsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;